/**
 * 提交拍卖信息
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 提交拍卖信息
// 接口地址   /api/v1/auctions/submit_car_auction/{auction_id}
Mock.mock(/\/auctions\/submit_car_auction\/\d/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'auction_date': '2018-06-22', // 开拍时间
    'auction_car_id': 1664, // 车辆id
    'minimum_price': 1000000, // 起拍价
    'session': {
      'id': 32, // 场次id
      'name': '广深场', // 场次名称
      'start_at': '08:00', // 开拍时间
      'start_date': '2018-06-23', // 开拍日期
      'cars': 1, // 已上拍车辆数
      'citys': [{
        'id': 440300, // 城市编号
        'name': '深圳市' // 城市名
      }]
    }
  }
})
Mock.mock(/\/auctions\/submit_car_auction\/\d/, 'post' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'id': 1, // 拍卖活动ID
    'status': 2, // 拍卖状态
    'status_code': 'editing', // 状态代码
    'mp_share_url': 'http://ucwx.cheanjia.com/#/aucCar/1', // 分享页URL
    'minimum_price': '19999900', // 起拍价，单位：分
    'reserve_price': '21999900', // 保留价，单位：分
    'maximum_price': '23999900', // 最高价，单位：分
    'sequence': 13, // 开拍顺序
    'store_name': '东莞雷克萨斯', // 4s店名
    'auction_session': { // 拍卖场次
      'id': 2, // 场次ID
      'name': '2017年3月22日 18:00场',
      'status': 2, // 场次状态：1 未开始，2 进行中，3 已结束
      'status_code': 'processing', // 状态代码
      'auction_count': 11, // 当前参与该场次拍卖数量
      'started_at': '2017-03-22 18:00:00',
      'ended_at': '2017-03-22 23:59:59'
    },
    'auction_car': { // 拍卖车辆
      'id': 3, // 拍卖车辆ID
      'car_model_name': '汉兰达 2015款 2.0T 自动 两驱 精英版 5座', // 车型名称
      'mileage': 99999, // 里程，单位：公里
      'car_image_url': 'http://img3.bitautoimg.com/autoalbum/files/20150324/003/16465300339630_3948382_2.jpg', // 车辆照片
      'location_city': '东莞', // 车辆所在地
      'licensed_at': '2017-03-22' // 上牌时间
    }
  }
})
